type Person = {
	firstname?: string | null;
	lastname?: string | null;
};

/**
 * Gives concatenated person "firstname" and "lastname" with no empty values.
 */
export default function makePersonName(person: Person): string {
	const {firstname, lastname} = person;
	const chunks = [firstname, lastname].map((v) => v?.trim()).filter((v) => v);

	if (!chunks.length) {
		return '';
	}

	return chunks.join(' ');
}
